import {Client} from '@stomp/stompjs';
import SockJS from 'sockjs-client';

export const stompClient = new Client({
    webSocketFactory: () => new SockJS(process.env.REACT_APP_SOCKET_URL),
    reconnectDelay: 5000,
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000,
});